"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('road', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(6.000000, 5.091863)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("path", {
    d: "M5,0.908136641 L0,36.9081366"
  }), _react.default.createElement("path", {
    d: "M36.9287415,0.908136641 L31.9643708,36.8633744",
    transform: "translate(33.964371, 18.886476) scale(-1, 1) translate(-33.964371, -18.886476) "
  }), _react.default.createElement("path", {
    d: "M18,0.908136641 L18,6.90813664"
  }), _react.default.createElement("path", {
    d: "M18,29.9081366 L18,36.9081366"
  }), _react.default.createElement("path", {
    d: "M18,14.9081366 L18,21.9081366"
  }))));
});

exports.default = _default;